import { render, staticRenderFns } from "./system.vue?vue&type=template&id=5afa806a&scoped=true&"
var script = {}
import style0 from "./system.vue?vue&type=style&index=0&id=5afa806a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa806a",
  null
  
)

export default component.exports